export default __webpack_public_path__ + "static/media/check_icon.b360c568.png";